import { InertiaLink, useForm } from '@inertiajs/inertia-react';
import Layout from 'app/admin/Layout';
import Form from 'app/fragments/Forms/Form';
import React, { useContext } from 'react';
import Select from 'app/fragments/Forms/Select';
import WhiteContainer from 'app/admin/WhiteContainer';
import Button from 'app/components/Buttons/Button';
import Icon from 'app/components/Icon';
import route from 'ziggy-js';
import { ModalsContext, MODALS } from 'app/components/Layouts/Modals';
import { defaultButtons } from 'app/admin/ConfirmModal';

interface Inquiry {
    id: number;
    event_type: 'cafe' | 'custom';
    package_type?: 'exclusive' | 'standard' | 'basic' | 'custom';
    package_index?: number;
    layout?: 'rozvrzeni1' | 'rozvrzeni2';
    person_count: number;
    menu_custom?: any;
    /*  menu_custom_total_price?: number; */
    menu_total_price?: number;
    total_price?: number;
    street?: string;
    zip?: string;
    city?: string;
    company?: string;
    name: string;
    surname: string;
    phone: string;
    email: string;
    request?: string;
    created_at: string;
}

interface Props {
    inquiries?: Inquiry[];
    pagination?: {
        from: number;
        to: number;
        total: number;
        prev_page_url: string | null;
        next_page_url: string | null;
    };
}

function Index({ inquiries = [], pagination }: Props) {
    const { open, close } = useContext(ModalsContext);
    const form = useForm({
        paginate: '10',
    });

    const formatEventType = (type: string) => type === 'cafe' ? 'Kavárna' : 'Vlastní';
    const formatPackageType = (type?: string) => {
        if (!type) return '';
        switch (type) {
            case 'exclusive': return 'Exkluzivní';
            case 'standard': return 'Standardní';
            case 'basic': return 'Základní';
            case 'custom': return 'Vlastní';
            default: return type;
        }
    };

    return (
        <Layout>
            <div className="pt-40px pb-130px">
                <div className="flex justify-between items-center gap-32px">
                    <div className="text-h32 font-semibold flex-shrink-0">Catering</div>
                    <div className="flex items-center gap-32px">
                        <div className="flex items-center mt-18px justify-end">
                            <div className="mr-16px text-66666">Položek na stránku</div>
                            <Form form={form} className="w-70px">
                                <Select
                                    name="paginate"
                                    placeholder="10"
                                    options={[
                                        { text: '10', value: '10' },
                                        { text: '20', value: '20' },
                                        { text: '50', value: '50' },
                                        { text: '100', value: '100' },
                                    ]}
                                    onChange={(value) => form.setData('paginate', value)}
                                />
                            </Form>
                        </div>
                        <Button href={'/'} /* href={route('admin.catering.create')} */>
                            <Icon className="pr-16px" name="plus" />
                            Přidat poptávku
                        </Button>
                    </div>
                </div>

                <WhiteContainer className="mt-40px">
                    <table className="w-full">
                        <thead>
                            <tr className="text-left border-b border-eee">
                                <th className="py-16px font-semibold">Jméno</th>
                                <th className="py-16px font-semibold">Typ události</th>
                                <th className="py-16px font-semibold">Kontaktní údaje</th>
                                <th className="py-16px font-semibold">Datum vytvoření</th>
                                <th className="py-16px font-semibold text-right">Akce</th>
                            </tr>
                        </thead>
                        <tbody>
                            {inquiries.length === 0 ? (
                                <tr>
                                    <td colSpan={5} className="py-16px text-center">
                                        Žádné poptávky nebyly nalezeny
                                    </td>
                                </tr>
                            ) : (
                                inquiries.map((inquiry) => (
                                    <tr key={inquiry.id} className="border-b border-eee">
                                        <td className="py-16px">
                                            <InertiaLink
                                                href={route('admin.catering.show', { inquiry: inquiry.id })}
                                                className="text-blue-600 hover:text-blue-800"
                                            >
                                                {`${inquiry.name} ${inquiry.surname}`}
                                            </InertiaLink>
                                        </td>
                                        <td id={`inquiry-type-${inquiry.id}`} className="py-16px">
                                            {formatEventType(inquiry.event_type)}
                                            {inquiry.package_type && ` - ${formatPackageType(inquiry.package_type)}`}
                                        </td>
                                        <td className="py-16px">
                                            {inquiry.email}<br />{inquiry.phone}
                                        </td>
                                        <td className="py-16px">
                                            {new Date(inquiry.created_at).toLocaleDateString('cs-CZ')}
                                        </td>
                                        <td className="py-16px text-right">
                                            <div className="flex justify-end gap-8px">
                                                <InertiaLink
                                                    href={route('admin.catering.show', { inquiry: inquiry.id })}
                                                    className="text-blue-600 hover:text-blue-800"
                                                >
                                                    <Icon name="eye" />
                                                </InertiaLink>
                                                <InertiaLink
                                                    href={'/'} /* href={route('admin.catering.edit', { inquiry: inquiry.id })} */
                                                    className="text-blue-600 hover:text-blue-800"
                                                >
                                                    <Icon name="pencil" />
                                                </InertiaLink>
                                                <button
                                                    /* onClick={(e) => removeInquiry(e, inquiry.id)} */
                                                    className="text-red-600 hover:text-red-800"
                                                >
                                                    <Icon name="trash" />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>

                    {pagination && (
                        <div className="flex justify-between items-center mt-24px">
                            <div className="text-sm text-gray-500">
                                Zobrazeno {pagination.from}-{pagination.to} z {pagination.total} poptávek
                            </div>
                            <div className="flex gap-8px">
                                <button
                                    className={`px-12px py-8px ${!pagination.prev_page_url ? 'opacity-50 cursor-not-allowed' : ''}`}
                                    disabled={!pagination.prev_page_url}
                                    onClick={() => pagination.prev_page_url && form.get(pagination.prev_page_url)}
                                >
                                    Předchozí
                                </button>
                                <button
                                    className={`px-12px py-8px ${!pagination.next_page_url ? 'opacity-50 cursor-not-allowed' : ''}`}
                                    disabled={!pagination.next_page_url}
                                    onClick={() => pagination.next_page_url && form.get(pagination.next_page_url)}
                                >
                                    Další
                                </button>
                            </div>
                        </div>
                    )}
                </WhiteContainer>
            </div>
        </Layout>
    );
}

export default Index;
